import { createPortal } from "react-dom";
import {
  MainFooter,
  StyledContainerFooter,
  StyledfooterH4,
  StyledfooterH5,
  StyledLink,
  Styledol,
  CopyRight,
  Styledp,
  StyledIconButton,
} from "./Footer.style";
import Container from "@mui/material/Container";
import { Grid } from "@mui/material";
import ContactCM from "components/contactus";
import AppbarCM from "components/appbar";
import DadekavwebLogo from "assets/img/DadekavwebLogo.png";
import { useCallback, useEffect, useState } from "react";
import { getContactUsRequest } from "api/requests";
import useHttp from "hooks/use-http";
import MenuIcon from "@mui/icons-material/Menu";
import { BsInstagram, BsTelegram, BsWhatsapp } from "react-icons/bs";
import PhoneIcon from "@mui/icons-material/Phone";
import useAuth from "hooks/use-auth";

export default function FooterCM() {
  const AuthCTX = useAuth();
  const { request } = useHttp();
  const [contact, setContact] = useState([]);

  const getMessages = useCallback(async () => {
    let resContact = await request({
      url: getContactUsRequest,
      values: {},
    });
    setContact(resContact);
  }, [request]);

  useEffect(() => {
    getMessages();
  }, []);

  return createPortal(
    <>
      <MainFooter>
        <Container>
          <StyledContainerFooter>
            <Grid container my={2} spacing={1} sx={{ direction: "ltr" }}>
              {/* <Grid item md={6} xs={12}>
                <StyledfooterH4>تولیدی مبلمان ویول</StyledfooterH4>
                <Styledp>
                  شرکت تولیدی نگين کاج شمال در قالب یک مغازه کوچک و استیجاری در
                  صنف نجاری به سال 1379 در قائمشهر از شهرستان استان مازندران
                  شروع به کار کرد. در سال 1381 از مغازه به کارگاه تولید مبل
                  تبدیل شد و در سال 1389 با همراهی مشتریان عزیز از کارگاه به
                  کارخانه و بصورت شرکت تولیدی و صنعتی در شهرک صنعتی سنگتاب ادامه
                  مسیر را طی نمود. دستگاههای قدیمی فرسوده شد و دستگاههای جدید
                  جای آنها را گرفت، افراد زیادی در این مجموعه اشتغال داشته و
                  دارند، مدل مبلمان دستخوش تغییرات زیادی گردید و تنها یک اصل
                  بدون هیچ گونه تغییری باقیمانده و آن اصل "صداقت" است.
                </Styledp>
              </Grid> */}
              <Grid item md={3} xs={6}>
                <StyledfooterH4>موارد بیشتر</StyledfooterH4>
                <Styledol>
                  <li>
                    <StyledLink to="/branch">شعبات حضوری</StyledLink>
                  </li>
                  <li>
                    <StyledLink to="/payment/rules">نحوه ثبت سفارش</StyledLink>
                  </li>
                  <li>
                    <StyledLink to="/payment/rules">نحوه پرداخت</StyledLink>
                  </li>
                  <li>
                    <StyledLink to="/payment/rules">
                      نحوه ارسال سفارش
                    </StyledLink>
                  </li>
                </Styledol>
              </Grid>
              <Grid item md={3} xs={6}>
                <StyledfooterH4>موارد بیشتر</StyledfooterH4>
                <Styledol>
                  <li>
                    <StyledLink to="/aboutus">درباره ما</StyledLink>
                  </li>
                  <li>
                    <StyledLink to="/contact">تماس با ما</StyledLink>
                  </li>
                  <li>
                    <StyledLink to="/article">آموزش</StyledLink>
                  </li>
                  {!AuthCTX.isLoggedIn ? (
                    <li>
                      <StyledLink to="/login">ورود | ثبت نام</StyledLink>
                    </li>
                  ) : (
                    <li>
                      <StyledLink to="/profile">حساب کاربری</StyledLink>
                    </li>
                  )}
                </Styledol>
              </Grid>
              <Grid item md={3} xs={6}>
                <StyledfooterH4>اطلاعات بیشتر</StyledfooterH4>
                <Styledol>
                  <li>
                    <StyledLink to="/rules">قوانین سایت</StyledLink>
                  </li>
                  <li>
                    <StyledLink to="/privacy">حریم خصوصی</StyledLink>
                  </li>
                  <li>
                    <StyledLink to="/questions">پرسش های متداول</StyledLink>
                  </li>
                  <li>
                    <StyledLink to="/complaint">ثبت شکایت</StyledLink>
                  </li>
                </Styledol>
              </Grid>
              <Grid item md={3} xs={6}>
                <StyledfooterH4>مجوز ها</StyledfooterH4>
                {/* <Styledol>
                  <a
                    referrerPolicy="origin"
                    target="_blank"
                    href="https://trustseal.enamad.ir/?id=298367&Code=5M6UJ8Fuy25vjoHcL3nW"
                    style={{ width: "120px", display: "inline-block" }}
                  >
                    <img
                      referrerPolicy="origin"
                      src="https://Trustseal.eNamad.ir/logo.aspx?id=298367&Code=5M6UJ8Fuy25vjoHcL3nW"
                      alt="نماد اعتماد الکترونیک"
                      id="5M6UJ8Fuy25vjoHcL3nW"
                    />
                  </a>
                </Styledol> */}
              </Grid>
            </Grid>
            <Grid container my={2} spacing={1} sx={{ direction: "ltr" }}>
              <Grid item md={6} xs={12}>
                <StyledfooterH5>ارتباط با ما بخش مبلمان</StyledfooterH5>
                <div>
                  <StyledIconButton
                    aria-label="more"
                    id="long-button"
                    aria-haspopup="true"
                  >
                    <a href={"tel:" + contact?.a?.phone_number} target="_blank">
                      <PhoneIcon style={{ color: "white" }} />
                    </a>
                  </StyledIconButton>
                  <StyledIconButton
                    aria-label="more"
                    id="long-button"
                    aria-haspopup="true"
                  >
                    <a
                      href={
                        "https://www.instagram.com/" + contact?.a?.instagram
                      }
                      target="_blank"
                    >
                      <BsInstagram style={{ color: "white" }} />
                    </a>
                  </StyledIconButton>
                  <StyledIconButton
                    aria-label="more"
                    id="long-button"
                    aria-haspopup="true"
                  >
                    <a
                      href={"https://t.me/" + contact?.a?.telegram}
                      target="_blank"
                    >
                      <BsTelegram style={{ color: "white" }} />
                    </a>
                  </StyledIconButton>
                  <StyledIconButton
                    aria-label="more"
                    id="long-button"
                    aria-haspopup="true"
                  >
                    <a
                      href={"https://wa.me/" + contact?.a?.email}
                      target="_blank"
                    >
                      <BsWhatsapp style={{ color: "white" }} />
                    </a>
                  </StyledIconButton>
                </div>
              </Grid>

              <Grid item md={6} xs={12}>
                <StyledfooterH5>ارتباط با ما بخش اکسسوری</StyledfooterH5>
                <div>
                  <StyledIconButton
                    aria-label="more"
                    id="long-button"
                    aria-haspopup="true"
                  >
                    <a href={"tel:" + contact?.b?.phone_number} target="_blank">
                      <PhoneIcon style={{ color: "white" }} />
                    </a>
                  </StyledIconButton>
                  <StyledIconButton
                    aria-label="more"
                    id="long-button"
                    aria-haspopup="true"
                  >
                    <a
                      href={
                        "https://www.instagram.com/" + contact?.b?.instagram
                      }
                      target="_blank"
                    >
                      <BsInstagram style={{ color: "white" }} />
                    </a>
                  </StyledIconButton>
                  <StyledIconButton
                    aria-label="more"
                    id="long-button"
                    aria-haspopup="true"
                  >
                    <a
                      href={"https://t.me/" + contact?.b?.telegram}
                      target="_blank"
                    >
                      <BsTelegram style={{ color: "white" }} />
                    </a>
                  </StyledIconButton>
                  <StyledIconButton
                    aria-label="more"
                    id="long-button"
                    aria-haspopup="true"
                  >
                    <a
                      href={"https://wa.me/" + contact?.b?.email}
                      target="_blank"
                    >
                      <BsWhatsapp style={{ color: "white" }} />
                    </a>
                  </StyledIconButton>
                </div>
              </Grid>
            </Grid>
          </StyledContainerFooter>
        </Container>
        <CopyRight>
          <a href="https://dadekavweb.ir" target="_blank">
            <img src={DadekavwebLogo} alt="dadekavweb" />
          </a>
          <a href="https://dadekavweb.ir" target="_blank">
            طراحی این وبسایت توسط شرکت <b>داده کاو وب</b> انجام شده است
          </a>
        </CopyRight>
        <AppbarCM />
      </MainFooter>
    </>,
    document.getElementById("footer")
  );
}
